import { Grid, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../constants/FieldsConst';
import { validMessage } from '../../../constants/ValidsFormConst';
import { soloPhone } from '../../../helpers';
import { LoadingWidget } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { saveTelefonosAction } from '../TelefonosAction';
// import SelectFieldOperadorasComponent from '../../sistema/operadoras/components/SelectFieldOperadoras';
import { FormControlLabel, Switch, Typography } from '@mui/material';
import { useNotification } from '../../../helpers/Notification';

const FormTelefonos = ({ setOpenModalForm, params }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  // const operadorasStore = Redux.useSelector((state) => state.operadoras);
  const telefonosStore = Redux.useSelector((state) => state.telefonos);

  const activo = telefonosStore.activo;

  const initData = {
    numero: '',
    idOperadora: 1,
    isPrincipal: true,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    numero: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  // React.useEffect(() => {
  //   if (data.operadora) {
  //     const operadora = operadorasStore.all.find(
  //       (el) => el.id === data.operadora,
  //     );
  //     _handleSetDataField(CONST.operad.name, `${operadora?.prefijo}`);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [data.operadora]);

  React.useEffect(() => {
    if (!activo) return;
    setTimeout(
      () =>
        setData({
          isPrincipal: activo.isPrincipal,
          idOperadora: activo.operadora?.id ?? 1,
          numero: activo.numero ?? '',
        }),
      300,
    );
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveTelefonosAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          numero: data.numero.toString(),
          ...params,
        },
        {
          ...params,
          ...telefonosStore.params,
        },
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.numero.name}
            value={data.numero ?? ''}
            required
            label={CONST.numero.label}
            onChange={(e) => {
              const value = soloPhone(e.target.value);
              _handleSetDataField(CONST.numero.name, value);
            }}
            helperText={dataError.numero ? validMessage.required : null}
            error={dataError.numero}
          />
          <Typography variant="caption" color="grey">
            Ejemplo: +584241112233
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControlLabel
            control={
              <Switch
                checked={data.isPrincipal}
                onChange={(event) => {
                  _handleSetDataField(
                    CONST.isPrincipal.name,
                    event.target.checked,
                  );
                }}
              />
            }
            label="Número principal"
          />
        </Grid>
        {/* 
        <Grid item xs={12} md={6}>
          <SelectFieldOperadorasComponent
            value={data.idOperadora}
            onChange={(idOperadora) => {
              _handleSetDataField(CONST.idOperadora.name, idOperadora);
            }}
          />
        </Grid> */}

        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormTelefonos;
